import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5605a637"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "createComment",
  tabindex: "-1",
  "aria-labelledby": "createComment",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block mb-2 fs-7" }, "2021/08/26 09:24", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0 fs-7" }, " コメントコメントコメントコメントコメントコメントコメントテキストテキストテキストテキストテキストテキストテキストテキストテキスト ", -1))
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "camera" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-camera" })
], -1))
const _hoisted_9 = ["placeholder"]

import Avatar from '@/components/avatar/index.vue'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import { translate } from '@/languages/i18n'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3], (item) => {
            return _createElementVNode("div", {
              class: "user d-flex mb-4",
              key: item
            }, [
              _createVNode(Avatar, { size: 'small' }),
              _createElementVNode("div", null, [
                _createVNode(UserAliasIcon, {
                  title: '貝堀 智美',
                  class: "mb-2 fw-bold"
                }),
                _hoisted_5,
                _hoisted_6
              ])
            ])
          }), 64)),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("input", {
              type: "text",
              placeholder: _unref(translate)('writeComment'),
              class: "form-control"
            }, null, 8, _hoisted_9)
          ])
        ])
      ])
    ])
  ]))
}
}

})